import { render, staticRenderFns } from "./ManualProtesto.vue?vue&type=template&id=8520e9a0"
import script from "./ManualProtesto.vue?vue&type=script&lang=js"
export * from "./ManualProtesto.vue?vue&type=script&lang=js"
import style0 from "./ManualProtesto.vue?vue&type=style&index=0&id=8520e9a0&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dartanghanvani/Documents/workspace/recuperi-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8520e9a0')) {
      api.createRecord('8520e9a0', component.options)
    } else {
      api.reload('8520e9a0', component.options)
    }
    module.hot.accept("./ManualProtesto.vue?vue&type=template&id=8520e9a0", function () {
      api.rerender('8520e9a0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ManualProtesto.vue"
export default component.exports